import { render, staticRenderFns } from "./ServiceDashboardLateTutorCard.vue?vue&type=template&id=8d9122c2&scoped=true&"
import script from "./ServiceDashboardLateTutorCard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardLateTutorCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardLateTutorCard.vue?vue&type=style&index=0&id=8d9122c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9122c2",
  null
  
)

export default component.exports